module.exports = __webpack_public_path__ + "static/media/map.3fbb2e96.png";